import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SOCIAL_LINKS, CONTACT_INFO } from '../../utils/constants';

export const Footer: React.FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative">
      {/* Background dengan subtle gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-bg-secondary/50 to-black/80"></div>

      <div className="relative z-10 container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <div className="mb-8">
              <div className="flex items-center space-x-3 mb-6">
                <img
                  src="/idngold_icon.webp"
                  alt="IDNGold Icon"
                  className="h-10 w-10"
                />
                <img
                  src="/idngold_text.webp"
                  alt="IDNGold"
                  className="h-8 w-auto"
                />
              </div>
              <p className="text-gray-400 mb-8 leading-relaxed max-w-md">
                {t('footer.tagline')}
              </p>

              {/* Social Links */}
              <div className="flex space-x-4">
                <a
                  href={SOCIAL_LINKS.TWITTER}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-gold transition-colors duration-300"
                  aria-label="Twitter"
                >
                  <i className="fab fa-twitter text-xl"></i>
                </a>
                <a
                  href={SOCIAL_LINKS.TELEGRAM}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-gold transition-colors duration-300"
                  aria-label="Telegram"
                >
                  <i className="fab fa-telegram text-xl"></i>
                </a>
                <a
                  href={SOCIAL_LINKS.DISCORD}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-gold transition-colors duration-300"
                  aria-label="Discord"
                >
                  <i className="fab fa-discord text-xl"></i>
                </a>
                <a
                  href={SOCIAL_LINKS.MEDIUM}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-gold transition-colors duration-300"
                  aria-label="Medium"
                >
                  <i className="fab fa-medium text-xl"></i>
                </a>
              </div>

            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-6 text-lg">{t('footer.quickLinks')}</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/about"
                  className="text-gray-400 hover:text-gold transition-colors duration-300"
                >
                  {t('footer.about')}
                </Link>
              </li>
              <li>
                <Link
                  to="/buy"
                  className="text-gray-400 hover:text-gold transition-colors duration-300"
                >
                  {t('footer.buyIdng')}
                </Link>
              </li>
              <li>
                <Link
                  to="/tokenomics"
                  className="text-gray-400 hover:text-gold transition-colors duration-300"
                >
                  {t('footer.tokenomics')}
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-gray-400 hover:text-gold transition-colors duration-300"
                >
                  {t('footer.faq')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources Links */}
          <div>
            <h3 className="text-white font-semibold mb-6 text-lg">{t('footer.resources')}</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/attestation"
                  className="text-gray-400 hover:text-gold transition-colors duration-300"
                >
                  {t('footer.attestation')}
                </Link>
              </li>
              <li>
                <Link
                  to="/compliance"
                  className="text-gray-400 hover:text-gold transition-colors duration-300"
                >
                  {t('footer.compliance')}
                </Link>
              </li>
              <li>
                <Link
                  to="/risk-disclosure"
                  className="text-gray-400 hover:text-gold transition-colors duration-300"
                >
                  {t('footer.riskDisclosure')}
                </Link>
              </li>
              <li>
                <Link
                  to="/redemption-policy"
                  className="text-gray-400 hover:text-gold transition-colors duration-300"
                >
                  {t('footer.redemptionPolicy')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-16 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              <p className="text-gray-500 text-sm">
                &copy; {currentYear} IDNGold. {t('footer.rightsReserved')}
              </p>
              <p className="text-gray-600 text-sm mt-1">
                <a
                  href={`mailto:${CONTACT_INFO.EMAIL}`}
                  className="text-gold hover:text-gold-light transition-colors duration-300"
                >
                  {CONTACT_INFO.EMAIL}
                </a>
              </p>
            </div>
            <div className="flex space-x-6">
              <a
                href="/compliance"
                className="text-gray-600 text-sm hover:text-gold transition-colors duration-300"
              >
                {t('footer.compliance')}
              </a>
              <a
                href="/redemption-policy"
                className="text-gray-600 text-sm hover:text-gold transition-colors duration-300"
              >
                {t('footer.redemptionPolicy')}
              </a>
              <a
                href="/risk-disclosure"
                className="text-gray-600 text-sm hover:text-gold transition-colors duration-300"
              >
                {t('footer.riskDisclosure')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer >
  );
};